import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dhats-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  @Input() title = '';
  @Input() isOpen = false;
  @Input() maxWidth = 'max-w-2xl';
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
